<template>
  <div class="bg-gradient-primary body">
    <div class="container">
      <div class="row justify-content-center">
        <div style="color:#fff;font-weight:bold;font-size:50px;margin-top:40px">MOTINOVA</div>
        <div
          class="col-md-9 col-lg-12 col-xl-10"
          style="margin-top: 20px; width: 800px"
        >
          <div class="card shadow-lg o-hidden border-0 my-5">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-lg-6 d-none d-lg-flex">
                  <p style="margin: auto auto !important; font-size: 20px">
                    {{ $t("title") }}
                  </p>
                </div>
                <div class="col-lg-6">
                  <div class="p-5" style="font-size: 16px">
                    <form class="user">
                      <div class="mb-3">
                        <div class="locale-changer">
                          <div style="margin: 10px; color: #555555">
                            {{ $t("lang") }}:
                          </div>
                          <select class="form-select" v-model="$i18n.locale">
                            <option
                              v-for="locale in $i18n.availableLocales"
                              :key="`locale-${locale}`"
                              :value="locale"
                            >
                              {{ locale }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <hr />
                      <div style="margin-top: 10px" class="mb-3">
                        <input
                          class="form-control form-control-user"
                          type="email"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          :placeholder="$t('usertip')"
                          name="email"
                          v-model="username"
                          @keyup.enter="doLogin"
                        />
                      </div>
                      <div class="mb-3">
                        <input
                          class="form-control form-control-user"
                          type="password"
                          id="exampleInputPassword"
                          :placeholder="$t('pstip')"
                          name="password"
                          v-model="password"
                          @keyup.enter="doLogin"
                        />
                      </div>
                      <button
                        type="button"
                        v-on:click="doLogin"
                        class="btn btn-primary d-block btn-user w-100"
                      >
                        {{ $t("login") }}
                      </button>
                      <hr />
                    </form>
                    <!-- <div class="text-center">
                      <a class="small" href="http://product.motinova.com/help">使用说明</a>
                    </div> -->
                    <div class="text-center">
                      <span class="small" style="color: #e74c3c">{{
                        $t("logintip")
                      }}</span>
                    </div>
                    <div class="text-center"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../common/httphelper";
import "../router/index";
import router from "../router/index";
import swal from "sweetalert2";

export default {
  name: "Login",
  data: function () {
    return {
      username: "",
      password: "",
    };
  },
  components: {},

  methods: {
    async doLogin() {
      var res = login(this.username, this.password);
      let that = this;
      await res.then(async function (response) {
        if (response.data.code == 20000) {
          await swal.fire({
            icon: "success",
            title: that.$t("loginsuccess"),
            showConfirmButton: false,
            timer: 1500,
          });
          sessionStorage.setItem("userid", response.data.data.token);
          sessionStorage.setItem("role", response.data.data.roleName);
          sessionStorage.setItem("name", response.data.data.realName);
          sessionStorage.setItem("id", response.data.data.id);
          sessionStorage.setItem("mail", that.username);

          if (
            navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
          ) {
            router.push("MobileHome");
            return;
          }
          router.push("Home");
        } else {
          await swal.fire({
            icon: "error",
            title: that.$t("loginfailed"),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.body {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>